var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,6,7,7V8L6,9H5L4,8V7L5,6Zm17.62,5.29-8-8-.26-.18-2-1L12.91,2H11.5l6,6,4.41,4.41v1.18l-4.14,4.15L16.5,19l-1.88,1.88.29.12h2l.71-.29,6-6,.29-.71V12Zm-4.91,3.42-6,6L12,21H10l-.71-.29-8-8-.18-.26-1-2L0,10V5l.29-.71,2-2L3,2H8l.45.11,2,1,.26.18,8,8L19,12v2ZM17,12.41,9.41,4.82,7.76,4H3.41L2,5.41V9.76l.82,1.65L10.41,19h1.18L17,13.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTags);
export default __webpack_public_path__ + "static/1779176049/media/icon-tags.0319616cc1c1d9eed36bff622849389d.svg";
export { ForwardRef as ReactComponent };